export default __webpack_public_path__ + "static/media/danger.d66fc2c2.svg";